const VIEW_AS_STORAGE_KEY = 'view_as_user_key'

export const readViewAsUserKey = () =>
  localStorage.getItem(VIEW_AS_STORAGE_KEY)

export const isViewAs = () => Boolean(readViewAsUserKey())

export const userPathKey = () => readViewAsUserKey() ?? 'me'

export const setViewAsUserKey = (userKey: string) =>
  localStorage.setItem(VIEW_AS_STORAGE_KEY, userKey)

export const clearViewAsUserKey = () =>
  localStorage.removeItem(VIEW_AS_STORAGE_KEY)
